import { all, put, takeEvery } from 'redux-saga/effects';

import {
    CREATE_PRIZE,
    UPDATE_PRIZE,
    DELETE_PRIZE
} from './constants';

import {
    requestPrizeCreation,
    requestPrizeUpdate,
    requestPrizeDelete
} from './api';

import {
    createPrizeSuccess,
    updatePrizeSuccess,
    deletePrizeSuccess
} from './actions';

/**
 *
 * @param actionObj
 * @returns {IterableIterator<PutEffect<{type, prize}>>}
 */
function* createPrize( actionObj ) {
    const prize = yield requestPrizeCreation( actionObj.calendarID );
    if ( prize ) {
        yield put( createPrizeSuccess( prize ) );
    }
}

/**
 *
 * @param actionObj
 * @returns {IterableIterator<PutEffect<{prizes, type}>>}
 */
function* updatePrize( actionObj ) {
    const prizes = yield requestPrizeUpdate( actionObj.prizeID, actionObj.prizeObj );
    if ( prizes ) {
        yield put( updatePrizeSuccess( prizes ) );
    }
}

/**
 *
 * @param actionObj
 * @returns {IterableIterator<PutEffect<{prizes, type}>>}
 */
function* deletePrize( actionObj ) {
    const prizes = yield requestPrizeDelete( actionObj.prizeID );
    if ( prizes ) {
        yield put( deletePrizeSuccess( prizes ) );
    }
}

/**
 *
 * @returns {IterableIterator<ForkEffect>}
 */
function* watchPrizes() {
    yield takeEvery( CREATE_PRIZE, createPrize );
    yield takeEvery( DELETE_PRIZE, deletePrize );
    yield takeEvery( UPDATE_PRIZE, updatePrize );
}

/**
 *
 * @returns {IterableIterator<AllEffect<IterableIterator<ForkEffect>>>}
 */
function* prizesSaga() {
    yield all( [
        watchPrizes()
    ] );
}

export default prizesSaga;